import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SwitchInverse, SwitchVariant } from '@frontend/sports/common/ui/sports-themed-switch';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { IBetslipRootState } from '../../base/store/state';
import { OddsPreferencePopupActions } from './actions';
import { OddsPreferencePopupService } from './odds-preference-popup.service';
import { oddsPreferencePopupStateSelector } from './selector';

@Component({
    selector: 'bs-betslip-odds-action',
    templateUrl: './odds-preference-popup.component.html',
    styleUrls: ['./odds-preference-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOddsActionComponent implements OnInit {
    enabled: boolean;
    visible$: Observable<boolean>;
    isEpcotTemplate = false;
    private readonly destroyRef = inject(DestroyRef);

    readonly variant: SwitchVariant = {
        'default': 'utility',
        'bwin-dark': 'neutral',
        'sportingbet-2': 'neutral',
    };

    themeInverseIndicator: SwitchInverse = {
        'sportingbet-2': { isInverse: true },
    };
    constructor(
        private store: Store<IBetslipRootState>,
        public sitecore: Sitecore,
        private oddsPreferencePopupService: OddsPreferencePopupService,
        private change: ChangeDetectorRef,
        private epcotConfig: EpcotConfig,
    ) {
        this.isEpcotTemplate = this.epcotConfig.isEnabled;
    }

    ngOnInit(): void {
        this.enabled = this.oddsPreferencePopupService.initializeService();
        this.visible$ = this.store
            .select(oddsPreferencePopupStateSelector)
            .pipe(map((state) => this.oddsPreferencePopupService.shouldShowReminder(state.disabled, state.counter)));
        this.oddsPreferencePopupService.revertOnFail$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.revert());
    }

    onValueChange(value: boolean): void {
        this.enabled = value;
        this.store.dispatch(OddsPreferencePopupActions.acceptOddsChange({ enable: this.enabled }));
    }

    revert() {
        this.enabled = !this.enabled;
        this.change.markForCheck();
    }
}
